import { render, staticRenderFns } from "./SponsorsList.vue?vue&type=template&id=76ea7a12&scoped=true&"
import script from "./SponsorsList.vue?vue&type=script&lang=js&"
export * from "./SponsorsList.vue?vue&type=script&lang=js&"
import style0 from "./SponsorsList.vue?vue&type=style&index=0&id=76ea7a12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76ea7a12",
  null
  
)

export default component.exports